import gql from "graphql-tag";

export const POPULATE_HISTORY_REPORT = gql`mutation populateHistoryReport($from: Date, $to: Date, $entityName: String, $entityFields: String, $filter: FilterInput, $entityId: Long, $reportType: String) {
  fieldsHistoryServiceCustomReport_populateReport(from: $from, to: $to, entityName: $entityName, entityFields: $entityFields, filter: $filter, entityId: $entityId, reportType: $reportType) 
}`